import ArrowRight from "./SVG/arrowRight.svg?react";

const ArrowRightIcon = () => {
  return <ArrowRight />;
};

export default ArrowRightIcon;
